import React,{useState, useEffect} from 'react';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jfeat(){

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>

<Sides/>
<Helmet>
 
  <title>Master the Art of Java Features: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="Java features tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java features,java 13 features,java 8 features with examples,java 14 features,java 8 features tutorial
,features of javascript,java 8 features interview questions,java features by version,java 8 features geeksforgeeks,java 11 features with examples
" />
<link rel="canonical" href="https://www.codeexampler.com/java-features" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java Features</h1>
    <div className="first">
        <a href="/java-history">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        
        </div>
    <h2 className="mt-4 mh2">Why We Use Java:</h2>
    <p className="para mt-4">1, Java is a case sensitive language<br/>
2, java is a popular language because  it is reliable, easy to use and simple<br/>
3, Java key permits to solve both the security and the portability problems.<br/>
4, Translating a Java program into bytecode it much easier to run a program because only the JVM needs to be executed for each platform.<br/>
5, this is a high performance and dynamic</p>
  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/java-history">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jfeat;